import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { hasSubscriptions } from '../../../../../selectors/pageLayout';
import { AppState } from '../../../../../../types/store';
import {
  getProfileOwnerIsWatcher,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../../selectors/users';
import { getCanCustomizePage } from '../../../../../selectors/privs';
import { blockProfileOwner } from '../../../../../actions/profileOwner';
import { Props } from './UserProfileSubNavDesktopInner';
import { hasPublicBirthday } from '../../../../../selectors/aboutMe';

type StateProps = Pick<
  Props,
  | 'isOwner'
  | 'profileOwnerUser'
  | 'isAuthorizedToCustomize'
  | 'isProfileOwnerWatchingCurrentUser'
  | 'isLoggedIn'
  | 'hasSubscriptions'
  | 'hasPublicBirthday'
>;
type DispatchProps = Pick<Props, 'blockProfileOwner'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isAuthorizedToCustomize: getCanCustomizePage(state),
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
  isLoggedIn: getIsLoggedIn(state),
  hasSubscriptions: hasSubscriptions(state),
  hasPublicBirthday: hasPublicBirthday(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  blockProfileOwner: () => dispatch(blockProfileOwner()),
});

export default connect(mapStateToProps, mapDispatchToProps);
